/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Startup_LeadInputs */

const en_mk_sol_startup_lead = /** @type {(inputs: Mk_Sol_Startup_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seven people doing product, sales and support at once. What is needed is not more tools but a way to make seven feel like twelve without adding payroll.`)
};

const id_mk_sol_startup_lead = /** @type {(inputs: Mk_Sol_Startup_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tujuh orang mengerjakan produk, penjualan, dan dukungan sekaligus. Yang dibutuhkan bukan lebih banyak alat, melainkan cara supaya tujuh orang terasa seperti dua belas tanpa menambah gaji.`)
};

/**
* | output |
* | --- |
* | "Seven people doing product, sales and support at once. What is needed is not more tools but a way to make seven feel like twelve without adding payroll." |
*
* @param {Mk_Sol_Startup_LeadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_startup_lead = /** @type {((inputs?: Mk_Sol_Startup_LeadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Startup_LeadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_startup_lead(inputs)
	return en_mk_sol_startup_lead(inputs)
});